// A process's icon, for the process lists (the dashboard's Activity, the workspace's Machine view): like Activity
// Monitor, the programs a person knows show their own logo, full colour, on an 18 tile; a shell is a Terminal tile;
// anything else (MainThread, Xorg, a kworker) keeps an empty 18 slot so the names stay in one column.

import { LOGOS, type LogoName } from './processLogos';
import './process-icon.css';

// first match wins, on the name only (lowercased, a path's last part): a worker such as MainThread runs vite in
// its command but isn't the program, so it stays blank
const RULES: [RegExp, LogoName | 'shell'][] = [
  [/^claude\b/, 'claude'],
  [/^codex\b/, 'codex'],
  [/^opencode\b/, 'opencode'],
  [/^gemini\b/, 'gemini'],
  [/^copilot\b/, 'copilot'],
  [/\bvite\b/, 'vite'],
  [/^(chrome|chromium|google-chrome)/, 'chrome'],
  [/^firefox/, 'firefox'],
  [/^(npm|npx)\b/, 'npm'],
  [/^pnpm\b/, 'pnpm'],
  [/^yarn\b/, 'yarn'],
  [/^(node|nodejs)\b/, 'node'],
  [/^bun\b/, 'bun'],
  [/^deno\b/, 'deno'],
  [/^(python\d?(\.\d+)?|uvicorn|gunicorn|celery)\b/, 'python'],
  [/^(go|gopls)$/, 'go'],
  [/^(cargo|rustc|rust-analyzer)\b/, 'rust'],
  [/^(docker|dockerd|containerd)/, 'docker'],
  [/^git\b/, 'git'],
  [/^(code|code-server)\b/, 'vscode'],
  [/^postgres/, 'postgres'],
  [/^(mysqld?|mariadbd)\b/, 'mysql'],
  [/^redis-server\b/, 'redis'],
  [/^mongod\b/, 'mongo'],
  [/^nginx\b/, 'nginx'],
  [/^(zsh|bash|sh|fish|dash)$/, 'shell'],
];

function markOf(name: string) {
  const n = name.trim().toLowerCase().split('/').pop() ?? '';
  for (const [re, m] of RULES) if (re.test(n)) return m;
  return null;
}

/** The process's logo on its tile, or the same-size empty slot. */
export function ProcessIcon({ name }: { name: string }) {
  const m = markOf(name);
  if (!m) return <span className="proc-icon" data-none="" aria-hidden="true" />;
  if (m === 'shell')
    return (
      <span className="proc-icon" data-shell="" aria-hidden="true">
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          stroke="#fff"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M4.5 5.5 6.75 7.5 4.5 9.5M8 10h3" />
        </svg>
      </span>
    );
  const l = LOGOS[m];
  return (
    <span className="proc-icon" aria-hidden="true">
      <svg width="12" height="12" viewBox={l.vb} dangerouslySetInnerHTML={{ __html: l.body }} />
    </span>
  );
}
